const DEFAULT_AUTH_URL = '/auth/?backurl=/personal/&popup=Y';
const SHEET_OPTIONS = {
  bodyClass: 'catalog-sheet-open',
  setHidden: true,
};

function getSheet() {
  return document.getElementById('auth-sheet');
}

function getFrame() {
  const sheet = getSheet();
  return sheet ? sheet.querySelector('iframe') : null;
}

function setLoading(isLoading) {
  const sheet = getSheet();
  if (!sheet) {
    return;
  }
  sheet.classList.toggle('is-loading', isLoading);
  sheet.setAttribute('aria-busy', isLoading ? 'true' : 'false');
}

function isBlankFrame(frame) {
  const src = frame.getAttribute('src') || '';
  return src === '' || src === 'about:blank';
}

function bindFrameLoader(frame) {
  if (frame.dataset.authLoaderBound === '1') {
    return;
  }
  frame.dataset.authLoaderBound = '1';

  frame.addEventListener('load', () => {
    if (isBlankFrame(frame)) {
      return;
    }
    setLoading(false);
    try {
      frame.contentWindow.addEventListener('beforeunload', () => {
        setLoading(true);
      });
    } catch (e) {
      // ignore cross-origin
    }
  });
}

export function openAuthSheet(url) {
  const sheet = getSheet();
  const AUTH_URL = url || DEFAULT_AUTH_URL;
  if (!sheet || !window.CatalogSheet) {
    window.location.href = url || '/auth/?backurl=/personal/';
    return;
  }

  const frame = getFrame();
  if (frame) {
    bindFrameLoader(frame);
    if (frame.getAttribute('src') !== AUTH_URL) {
      setLoading(true);
      frame.src = AUTH_URL;
    } else {
      setLoading(false);
    }
  }

  if (sheet.parentElement !== document.body) {
    document.body.appendChild(sheet);
  }

  window.CatalogSheet.open(sheet, SHEET_OPTIONS);
}

export function closeAuthSheet() {
  const sheet = getSheet();
  if (!sheet || !window.CatalogSheet) {
    return;
  }
  window.CatalogSheet.close(sheet, SHEET_OPTIONS);
}

export function initAuthSheet() {
  if (document.documentElement.dataset.authSheetInited === '1') {
    return;
  }
  document.documentElement.dataset.authSheetInited = '1';

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }
    const closeBtn = target.closest('#auth-sheet [data-catalog-sheet-close]');
    if (!closeBtn) {
      return;
    }
    event.preventDefault();
    closeAuthSheet();
  });

  document.addEventListener('keydown', (event) => {
    const sheet = getSheet();
    if (event.key === 'Escape' && sheet && window.CatalogSheet?.isOpen(sheet)) {
      closeAuthSheet();
    }
  });
}

window.ProstocvetOpenAuthSheet = openAuthSheet;
window.ProstocvetCloseAuthSheet = closeAuthSheet;
